var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueTray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 96,
    viewBox: "0 0 140 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 47.7255V64.0421L56 16.5755V0.258789L140 47.7255Z",
    fill: "#3FB9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56 0.258789L0 31.9032V47.7254L56 16.081V0.258789Z",
    fill: "#019DF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 26.9587L0 31.9032V47.7253L22 35.3643L9 26.9587Z",
    fill: "#028DD9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56 0.258789L137.5 46.2421L140 47.7255V50.1977L56 2.23657V0.258789Z",
    fill: "#A8E0FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140 63.5477L84 95.1922L0 47.7255L56 16.0811L140 63.5477Z",
    fill: "#83D9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106 82.8309L84 95.192L0 47.7254L21.9375 35.3218L106 82.8309Z",
    fill: "#75CEFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56 0.258789L0 31.9032L2 32.8921L56 2.23657V0.258789Z",
    fill: "#A8E0FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84 76.8976V92.2254L140 60.5809V48.7143L137.5 47.231L118 57.8615V66.0198L101 75.4143V69.9754L99 68.4921L92.5 72.2004L84 76.8976Z",
    fill: "#A8E0FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140 63.5475V47.7253L120.5 58.8503V67.0087L101 77.8865V69.9753L84 79.3698V95.192L140 63.5475Z",
    fill: "#2FBE9E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84 79.3699V76.8976L2 30.9143L0 31.9032L84 79.3699Z",
    fill: "#A8E0FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84 79.37V95.1922L0 47.7255V31.9033L84 79.37Z",
    fill: "#3FB9FC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M140 63.5475V47.7253L120.5 58.8503V67.0087L101 77.8865V69.9753L84 79.3698V95.192L140 63.5475Z",
    fill: "#019DF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTray);
export default __webpack_public_path__ + "static/media/blueTray.5eba6e33d10d17f47d8dc29e8b7c3208.svg";
export { ForwardRef as ReactComponent };